// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-card .el-form-item__label .el-input__inner {\n  border: 0 !important;\n  outline: none;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
